import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { LargeCard } from "../Home";
import PerksCardIcon from "static/images/PerksCardIcon.svg";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const PerksBanner = () => {
  const { isAdmin } = useRoleBasedView();

  return (
    <LargeCard block>
      <div className="t-h-full t-min-h-[132px] t-w-full t-bg-surface-lighter-grey t-rounded-lg t-border t-border-solid t-border-neutral-10 t-flex t-flex-col t-gap-3 t-p-5 md:t-flex-row md:t-items-start md:t-justify-between sm:t-justify-center">
        <div className="t-flex t-gap-3 t-items-start">
          <img
            className="t-h-8 t-w-8 sm:t-shrink-0"
            src={PerksCardIcon}
            alt=""
          />
          <div className="t-flex t-flex-col t-gap-1">
            <div className="t-text-subtext t-text-text-100">
              50+ perks from the best
            </div>
            <div className="t-text-body-sm t-text-text-30">
              Get access to 50+ perks from top brands to make sure you make the
              most for your company
            </div>
          </div>
        </div>
        <ConditionalLink
          to={isAdmin ? `perks` : "/community/perks"}
          className="t-block t-w-fit sm:t-ml-11"
        >
          <Button customType="secondary" size="small">
            View perks
          </Button>
        </ConditionalLink>
      </div>
    </LargeCard>
  );
};
